import Transformer from '../transformer'
import contactTransformer from './contact'
import secondContactTransformer from './secondContact'

export default class ModTransformer extends Transformer {
  static fetch(provider) {
    const contact = provider.profile ? contactTransformer.fetch(provider) : ''
    return {
      providerData: {
        id: provider.id,
        name: provider.name,
        lastName: provider.last_name,
        mothersLastName: provider.mothers_last_name,
        number: provider.provider_number,
        status: provider.status.name,
        files: provider.files
      },
      providerNumber: provider.provider_number,
      providerType: provider.provider_type.map(c => c.id),
      coreBusiness: provider.core_business.map(c => c.id),
      camps: provider.camp.map(c => c.id),
      commercialName: provider.commercial_name,
      capacity: provider.capacity,
      doesBill: provider.does_bill,
      rfc: provider.rfc,
      bill_zone: provider.bill_zone ? provider.bill_zone.id : null,

      hasTools: provider.has_tools,
      hasVehicle: provider.has_vehicle,
      hasCellphone: provider.has_cellphone,
      
      resico: provider.resico,
      retentionFourPercent: provider.retention_four_percent,
      retentionEightPercent: provider.retention_eight_percent,
      taxFree: provider.tax_free,
        
      bank: provider.account.bank ? provider.account.bank.id : null,
      accountNumber: provider.account.account_number,
      clabe: provider.account.clabe,
      cardNumber: provider.account.card_number,
      reference: provider.account.reference,
      contact,
    }
  }
  static send(data) {
    const finalData = {
      name: data.contact.contact,
      provider_type: data.providerType,
      core_business: data.coreBusiness,
      camp: data.camps,
      commercial_name: data.commercialName,
      does_bill: data.doesBill || false,
      rfc: data.rfc,
      capacity: data.capacity,
      bill_zone: data.bill_zone,
      has_tools: data.hasTools,
      has_vehicle: data.hasVehicle,
      has_cellphone: data.hasCellphone,
      resico: data.resico,
      retention_four_percent: data.retentionFourPercent,
      retention_eight_percent: data.retentionEightPercent,
      tax_free: data.taxFree,
      profile: {
        address: [
          {
            id: data.contact.address.id,
            state: data.contact.address.state,
            municipality: data.contact.address.municipality,
            street: data.contact.address.street,
            no_int: data.contact.address.noInt,
            no_ext: data.contact.address.noExt,
            colony: data.contact.address.colony,
            postal_code: data.contact.address.postalCode
          }
        ],
        phone: data.contact.cellphone,
        phone_ext: data.contact.phoneExt,
        alternative_email: data.contact.alternativeEmail,
        cellphone: data.contact.phone,
      },
      account: {
        bank: data.bank,
        account_number: data.accountNumber,
        clabe: data.clabe,
        card_number: data.cardNumber,
        reference: data.reference,
      }
    }
    if (Object.keys(data.contact.secondAddress).length !== 0) {
      finalData.profile.address.push(secondContactTransformer.send(data.contact.secondAddress))
    }
    return finalData
  }
}


// WEBPACK FOOTER //
// ./src/transformers/provider/index.js